import React from 'react'
import {Link} from 'gatsby'

const LeftMenu = props => (
  <div className="leftMenu">
    <ul>
      <li className={(props.active === 'home')? 'active' : ''}><Link to="/todays-students-tomorrows-america">Today&rsquo;s Students, Tomorrow&rsquo;s America Initiative</Link></li>
      <li className={(props.active === 'advisory-committee')? 'active' : ''}><Link to="/todays-students-tomorrows-america/advisory-committee">Honorary Advisory Committee</Link></li>      
      <li className={(props.active === 'board-of-directors')? 'active' : ''}><Link to="/todays-students-tomorrows-america/board-of-directors">Board of Directors</Link></li>      
    </ul>
  </div>
)

export default LeftMenu
